import { render, staticRenderFns } from "./IFrameLearningPage.vue?vue&type=template&id=ee2b9c04&scoped=true&"
import script from "./IFrameLearningPage.vue?vue&type=script&lang=js&"
export * from "./IFrameLearningPage.vue?vue&type=script&lang=js&"
import style0 from "./IFrameLearningPage.vue?vue&type=style&index=0&id=ee2b9c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2b9c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee2b9c04')) {
      api.createRecord('ee2b9c04', component.options)
    } else {
      api.reload('ee2b9c04', component.options)
    }
    module.hot.accept("./IFrameLearningPage.vue?vue&type=template&id=ee2b9c04&scoped=true&", function () {
      api.rerender('ee2b9c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/IFrameLearningPage.vue"
export default component.exports